import { TexeApi } from "../texeApi";
export const api = new TexeApi({ withCredentials: true });

// Initialize auth token from storage if present
try {
  const initial = localStorage.getItem("accessToken");
  if (initial) api.setAuthToken(initial);
} catch {}

// API Base URL export
export const API_BASE = api.baseUrl;

// Token management exports
export const getToken = () => localStorage.getItem("accessToken");
export const setToken = (token?: string | null) => {
  if (token) {
    localStorage.setItem("accessToken", token);
    api.setAuthToken(token);
  } else {
    localStorage.removeItem("accessToken");
    api.setAuthToken(undefined);
  }
};
export const clearToken = () => setToken(null);

// Refresh access token (placeholder)
export const refreshAccess = async () => {
  try {
    const res = await api.post<{ ok: boolean; access?: string; token?: string; accessToken?: string }>(
      "/api/auth/refresh",
      {}
    );
    const t = res.access || res.accessToken || res.token;
    if (t) {
      setToken(t);
      return t;
    }
  } catch {
    // ignore
  }
  return null;
};
